import React from "react";
import { Icon } from "@mdi/react";
import { mdiCheck } from "@mdi/js";
import styles from "./styles.scss";

const NewsletterFeatures = () => {
  const items = [
    {
      title: "BetQL Betting Guides",
      description:
        "Our daily betting guide are packed with BetQL model data and key betting trends you need to know for the day's biggest matchups",
    },
    {
      title: "Staff Picks",
      description: "Find out what bets our experts are targeting each day.",
    },
    {
      title: "Player Prop Projections",
      description:
        "See which player prop bets our experts and model are aligned on. Great way to spot value within any given slate.",
    },
    {
      title: "Exclusive Discounts",
      description:
        "It pays to be a free newsletter subscriber! Get first dibs on any promotions we run throughout the year",
    },
  ];

  return (
    <section className="newsletter-features">
      <div className="features-container">
        <h2 className="features-title">The PERKS</h2>

        <div className="features">
          {items.map(({ title, description }, index: number) => {
            return (
              <div key={index} className="feature">
                <div className="icon-container">
                  <Icon color="#fff" path={mdiCheck} size="16px" />
                </div>
                <div className="feature-detail">
                  <h3 className="feature-title">{title}</h3>
                  <p className="feature-description">{description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style jsx>{styles}</style>
    </section>
  );
};

export default NewsletterFeatures;
